import React from 'react';

const DOT_DIAMETER = 4;
const DOT_CENTER_TO_CENTER_DISTANCE = 6;
const DOT_ROW_COUNT = 3;
const DOT_FIELD_WIDTH = DOT_CENTER_TO_CENTER_DISTANCE + DOT_DIAMETER;
const DOT_ROW_CENTERS = Array.from(
  { length: DOT_ROW_COUNT },
  (_, rowIndex) => DOT_DIAMETER / 2 + rowIndex * DOT_CENTER_TO_CENTER_DISTANCE,
);
const DOT_FIELD_HEIGHT = DOT_ROW_CENTERS[DOT_ROW_CENTERS.length - 1] + DOT_DIAMETER / 2;

interface DragHandleProps {
  dragHandleProps?: React.HTMLAttributes<HTMLElement> | null;
  accessibleLabel: string;
  className?: string;
}

export const DragHandle = ({ dragHandleProps, accessibleLabel, className }: DragHandleProps) => (
  <span
    className={className ? `drag-handle-dots ${className}` : 'drag-handle-dots'}
    aria-label={accessibleLabel}
    {...dragHandleProps}>
    <svg
      width={DOT_FIELD_WIDTH}
      height={DOT_FIELD_HEIGHT}
      viewBox={`0 0 ${DOT_FIELD_WIDTH} ${DOT_FIELD_HEIGHT}`}
      fill="none"
      aria-hidden="true">
      {DOT_ROW_CENTERS.map((dotCenterY) => (
        <React.Fragment key={dotCenterY}>
          <circle cx={DOT_DIAMETER / 2} cy={dotCenterY} r={DOT_DIAMETER / 2} fill="currentColor" />
          <circle cx={DOT_FIELD_WIDTH - DOT_DIAMETER / 2} cy={dotCenterY} r={DOT_DIAMETER / 2} fill="currentColor" />
        </React.Fragment>
      ))}
    </svg>
  </span>
);
